import React from 'react';
import { Button, Tooltip } from '@mui/material';

/**
 * A full-width outlined action of the context panel. `blocker` says why it
 * cannot run and disables it; `hint` is the tooltip while it can.
 *
 * The admin's global stylesheet floats every `button` right
 * (`css/style.scss`, `button { float: right }`), which takes it out of the
 * flow and lets the next section draw over it. The wrapper is a flex box,
 * where floats are ignored, and the button clears the float as well.
 */
export function ActionButton({
  label,
  icon,
  blocker,
  hint,
  color,
  onClick,
}: {
  label: string;
  icon: React.ReactNode;
  blocker: string | null;
  hint?: string;
  color: 'primary' | 'error';
  onClick: () => void;
}) {
  const title = blocker ?? hint ?? '';
  return (
    <Tooltip title={title} disableHoverListener={!title} placement="left">
      <span style={{ display: 'flex', width: '100%' }}>
        <Button
          fullWidth
          variant="outlined"
          color={color}
          startIcon={icon}
          disabled={Boolean(blocker)}
          onClick={onClick}
          sx={{ justifyContent: 'flex-start', float: 'none', flex: 1 }}
        >
          {label}
        </Button>
      </span>
    </Tooltip>
  );
}
